import {
  DataField,
  Divider,
  H2,
  H3,
  Section,
  P,
  CheckList,
} from "./common-components";

export const CompletenessCheckList = ({ formType, documentation }) => {
  let reasons = [{ label: "Asked about Rx Medications from other individuals, MD samples, pharmacies and care providers", checked: false },
{ label: "Medications removed from home by the Pharmacist (if applicable)", checked: false },
{ label: "Asked about OTC products (including ASA)", checked: false },
{ label: "Asked about herbal or natural health products", checked: false },
{ label: "Prompted for Miscellaneous medications (ie/inhalers, topicals, eye drops, nasal sprays, patches, injectables, cannabis products)", checked: false },
{ label: "Asked about anti-infectives used in the last 3 months", checked: false },
{ label: "Referenced attached notes, results, references as appropriate", checked: false },
{ label: "Discussed circle of care, sharing information with other providers and the patient’s responsibility for providing accurate information (Included in Consent Form)", checked: false },
{ label: "Discussed anticipated date of completion of patient’s MedsCheck Personal Medication Record (if not available at the time of the MedsCheck) (Included in Consent Form)", checked: false },
{ label: "Ensure clinically relevant information is documented and readily retrievable for continuity of care and for audit purposes", checked: false },
{ label: "Other (Specify)", checked: false }];

  const neverAutoKeys = new Set([
    "medications removed from home by the pharmacist (if applicable)",
    "other (specify)",
  ]);
  const savedList = documentation?.completenessChecklist ?? [];
  const hasSavedData = savedList.length > 0;
  const checklistSet = new Set(savedList.map((item) => String(item).trim().toLowerCase()));

  let updatedReasons = reasons.map((reason) => {
    const key = reason.label.trim().toLowerCase();
    const checked = hasSavedData ? checklistSet.has(key) : !neverAutoKeys.has(key);
    return {
      ...reason,
      checked,
      label: reason.label === "Other (Specify)" ? `Other: ${documentation?.completenessChecklistComments ?? ""}` : reason.label,
    };
  });

  return (
    <Section formType={formType}>
      <H2>Checklist for Completeness</H2>
      <div className="flex flex-col gap-1">
        <CheckList list={updatedReasons} />
      </div>
    </Section>
  );
};
